module.exports = __webpack_public_path__ + "1cbf5740bf589211fc51710e26d18af6.jpg";